import { render, staticRenderFns } from "./LaudoRelatorioTerritorial.vue?vue&type=template&id=8ca1fd1c&scoped=true&lang=pug"
import script from "./LaudoRelatorioTerritorial.vue?vue&type=script&lang=js"
export * from "./LaudoRelatorioTerritorial.vue?vue&type=script&lang=js"
import style0 from "./LaudoRelatorioTerritorial.vue?vue&type=style&index=0&id=8ca1fd1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca1fd1c",
  null
  
)

export default component.exports